import React from "react";


function Button({ children, onClick, disabled, text, size = "large", fullWidth = false, color = "primary", setWidth = null, ...props }) {
    const sizeClass = `button-${size}`;
    const colorClass = `button-${color}`;
    var widthClass = fullWidth ? "button-full-width" : "";
    widthClass = setWidth ? "button-set-width" : widthClass

    // This might get unwieldy. Need to confirm it works.
    const style = {}
    if (setWidth) {
        // set width to the setWidth value
        style.width = setWidth;
        style.maxWidth = setWidth;
        // Remove horizontal padding
        style.paddingLeft = "0px";
        style.paddingRight = "0px";
        style.justifyContent = "center";
    }

    return (
        <button
            className={`button ${sizeClass} ${colorClass} ${widthClass} ${disabled ? "button-disabled" : ""}`}
            onClick={!disabled ? onClick : undefined}
            disabled={disabled}
            style={style}
            {...props}
        >
            {children}
        </button>
    );
};

export default Button;
